import * as React from 'react';

function SvgPlayCircleOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 25 25" }, props),
        React.createElement("path", { fill: "currentColor", d: "M10.694 16.07a.721.721 0 01-.357-.096.802.802 0 01-.397-.7v-5.91a.8.8 0 01.397-.7.716.716 0 01.729.01l5.051 3.023a.734.734 0 010 1.244l-5.052 3.024a.723.723 0 01-.371.104z" }),
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12.5 20.72a8.4 8.4 0 100-16.8 8.4 8.4 0 000 16.8zm0 1.6c5.523 0 10-4.478 10-10 0-5.524-4.477-10-10-10s-10 4.476-10 10c0 5.522 4.477 10 10 10z", clipRule: "evenodd" })));
}

export default SvgPlayCircleOutline;
